export const typesAddressall = {
    GET_ADDRESSALL_SUCCESS:'GET_ADDRESSALL_SUCCESS',
    GET_ADDRESSALL_ERROR:'GET_ADDRESSALL_ERROR',
    GET_ADDRESSALL_BEGIN:'GET_ADDRESSALL_BEGIN'
}
